<template>
  <div class="tab-pane fade show active" id="ug37Calculator">

    <!-- BOTÃO DESENHO DE APOIO -->
        <h5 class="text mt-5 text-primary">
            <b>Desenho de apoio</b>
        </h5>
      <div class="col-2">
          <button
          class="btn btn-secundario"
          @click="mostrarDesenho()"
          >
          Mostrar desenho
          </button>
      </div>
      <!-- POPUP COM O DESENHO -->
      <DesenhoApoio
      v-model="showDrawing"
      :tipo="7"
      />

    <h5 class="text mt-5 text-primary">
      <b>
        OPENING REINFORCEMENT PER ASME SECTION VIII, DIVISION 1, UG-37 TO UG-41
      </b>
    </h5>

    <form ref="formCalculo" @submit.prevent="calculos">

      <!-- 1. CONFIGURAÇÕES GERAIS -->
      <h5 class="text mt-5 text-primary"><b>1. GENERAL SETTINGS</b></h5>

      <div class="row mt-3">

        <label class="col-sm-8 col-form-label">
          <span><b>Are the nozzle and its reinforcement installed onto some weld?</b></span>
          <InterrogacaoHover text="Indica se o bocal está localizado sobre uma junta soldada do casco. Isso pode reduzir a eficiência estrutural conforme ASME VIII Div.1." />
        </label>

        <div class="col-sm-2">

          <select
            class="form-select w-50 w-md-75"
            v-model="bocalCalculator.soldaCostado"
           required>
            <option disabled value="">Selecione</option>
            <option value="1" selected>Yes</option>
            <option value="0">No</option>
          </select>

        </div>

      </div>

      <!-- 2. DADOS DE PROJETO -->
      <h5 class="text mt-5 text-primary"><b>2. PROJECT DATA</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">
          <thead>
            <tr>
              <th>DESCRIÇÃO</th>
              <th>SÍMBOLO</th>
              <th>VALOR</th>
              <th>UNIDADE</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Design Pressure</td>
              <td>P</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.pressaoProjeto }}
                </h6>
              </td>
              <td>N/mm²</td>
            </tr>
            <tr>
              <td>Design Temperature</td>
              <td>T</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.temperaturaProjeto }}
                </h6>
            </td>
              <td>°C</td>
            </tr>
            <tr>
              <td>Reference Temperature for the ASME B16.5 Class Range</td>
              <td>TWAMP</td>
              <td>
                <input class="form-control" v-model="bocalCalculator.temperaturaReferencia" type="number" step="any" required/>
              </td>
              <td>°C</td>
            </tr>

            <tr>
              <td><span><b>Internal Diameter of the Opening</b></span>
                <InterrogacaoHover text="Diâmetro interno da abertura no casco onde o bocal será instalado. Usado no cálculo da área removida." />
              </td>
              <td><b>d</b></td>
              <td><input class="form-control" v-model="bocalCalculator.diametroInternoAbertura" type="number" step="any" required/></td>
              <td><b>mm</b></td>
            </tr>
            <tr>
              <td><span>Internal Diameter of the Shell</span></td>
              <td>D</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.diametroInternoCasco }}
                </h6>
              </td>
              <td>mm</td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- 3. EFICIÊNCIAS E CORROSÃO -->
      <h5 class="text mt-5 text-primary"><b>3. EFFICIENCY AND CORROSION</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">
          <tbody>
            <tr>
              <td><span><b>Nozzle weld Joint Efficiency</b></span>
                <InterrogacaoHover text="Eficiência da junta soldada do bocal. Depende do tipo de solda e inspeção (radiografia, UT, etc.)." />
              </td>
              <td><b>En</b></td>
              <td><input class="form-control" v-model="bocalCalculator.eficienciaJuntaBocal" type="number" step="any" required/></td>
              <td><b>-</b></td>
            </tr>
            <tr>
              <td>Shell or head weld Joint Efficiency. If there is a weld crossing the nozzle, type here the local efficiency of weld.</td>
              <td>Ev</td>
              <td><input class="form-control" v-model="bocalCalculator.eficienciaJuntaCasco" type="number" step="any" required/></td>
              <td>-</td>
            </tr>
            <tr>
              <td><span><b>Nozzle Corrosion Allowance</b></span>
                <InterrogacaoHover text="Espessura adicional considerada para compensar perda por corrosão ao longo da vida útil." />
              </td>
              <td><b>Can</b></td>
              <td><input class="form-control" v-model="bocalCalculator.corrosaoAdmissivelBocal" type="number" step="any" required/></td>
              <td><b>mm</b></td>
            </tr>
            <tr>
              <td>Head or Shell Corrosion Allowance</td>
              <td>Cav</td>
              <td><input class="form-control" v-model="bocalCalculator.corrosaoAdmissivelCasco" type="number" step="any" required/></td>
              <td>mm</td>
            </tr>
            <tr>
              <td>Effective Inside Radius of Nozzle (CORRODED = d + 2 × C)</td>
              <td>Rn</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.raioInternoBocalCorroido }}
                </h6>
              </td>
              <td>mm</td>
            </tr>
            <tr>
              <td><span><b>Reinforcement Pad Thickness</b></span>
                <InterrogacaoHover text="Espessura da chapa de reforço (pad) adicionada ao redor do bocal para compensar a área removida." />
              </td>
              <td><b>te</b>te</td>
              <td><input class="form-control" v-model="bocalCalculator.espessuraChapaReforco" type="number" step="any" required/></td>
              <td><b>mm</b></td>
            </tr>
            <tr>
              <td>Allowable Stress of Reinforcement Pad Material</td>
              <td>Se</td>
              <td><input class="form-control" v-model="bocalCalculator.tensaoAdmissivelChapaReforco" type="number" step="any" required/></td>
              <td>N/mm²</td>
            </tr>
            <tr>
              <td>Reinforcement Pad Diameter <br><br>
                <b v-if="verificarLimiteDL()">Within the DL limit</b>
                <b v-else>Outside the DL limit</b>
                <InterrogacaoHover
                  v-if="!verificarLimiteDL()"
                  text="Attention: Outside of Limit DL, please verify."
                />
              </td>
              <td>Dp</td>
              <td><input class="form-control" v-model="bocalCalculator.diametroChapaReforco" type="number" step="any" required/></td>
              <td>mm</td>
            </tr>

            <!-- NON LARGE OPEN CRITÉRIOS -->
            <tr>
              <td>NON LARGE OPEN - for first criteria</td>
              <td></td>
              <td>
                <select class="form-select" disabled="true" v-model="bocalCalculator.soldaCostado">
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>NON LARGE OPEN - for second criteria</td>
              <td></td>
              <td>
                <select class="form-select" disabled="true" v-model="bocalCalculator.soldaCostado">
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </td>
              <td></td>
            </tr>

          </tbody>
        </table>

      </div>

      <!-- 4. DADOS DE MATERIAIS -->
      <h5 class="text mt-5 text-primary"><b>4. MATERIAL DATA</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">
          
          <h5 class="text mt-5 mb-5 text-primary"><b>4.1. DATA OF THE CONNECTED ELEMENT</b></h5>

          <tbody>
            <tr>
              <td>Material</td>
              <td style="white-space: nowrap;">
                <h6 class="text my-auto w-100">
                  {{ bocalCalculator.materialCasco }}
                </h6>
              </td>
            </tr>
            <tr>
              <td>Allowable Stress at Design Temperature (t)</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.tensaoAdmissivelCasco }}
                </h6>
              </td>
            </tr>
            <tr>
              <td>Minimum Required Thickness (Without Corrosion Allowance)</td>
              <td>
                <h6 class="text my-auto">
                  {{ espessuraMinimaCascoCalculada }}
                </h6>
              </td>
            </tr>
            <tr>
              <td>Nominal Thickness</td>
              <h6 class="text my-auto">
                  {{ bocalCalculator.espessuraNominalCasco }}
              </h6>
            </tr>
            <tr>
              <td>Corroded Thickness (Nominal Thickness - Corrosion Allowance)</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.espessuraCorroidaCasco }}
                </h6>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <div class="table-responsive material-table">

        <table class="table mt-3">

              <h5 class="text mt-5 mb-5 text-primary"><b>4.2. NOZZLE DESIGN DATA</b></h5>

          <tbody>
            <tr>
              <td>Material</td>
              <td>
                  <!-- Container com posição relativa para conter a lista -->
                  <div class="position-relative">
                      <!-- BUSCA -->
                      <div class="position-relative">
                          <input
                          type="search"
                          class="form-control ps-5 input w-100"
                          placeholder="Buscar material"
                          v-model="materialSearch"

                          @focus="abrirListaMaterial"
                          @click="abrirListaMaterial"
                          @input="handleInput"
                          @blur="fecharListaMaterial"
                          required
                          />

                          <!-- ÍCONE LUPA -->
                          <span
                              class="position-absolute start-0 top-50 translate-middle-y ps-3"
                          >
                              <img src="@/views/img/search-icon.svg" width="16" />
                          </span>
                      </div>

                      <!-- LISTA DE RESULTADOS - Agora dentro do container position-relative -->
                      <ul
                          v-if="mostrarListaMaterial && materiaisFiltrados.length"
                          class="material-options list-group position-absolute w-100 mt-1"
                      >
                          <li
                              class="material-option list-group-item list-group-item-action"
                              v-for="(material, index) in materiaisFiltrados"
                              :key="material.materialSpecification + index"
                              @mousedown.prevent="selecionarMaterial(material)"
                          >
                              <b>{{ [material.materialSpecification, material.classConditionTemper].filter(Boolean).join(" ") }}</b>
                          </li>
                      </ul>
                  </div>
              </td>
            </tr>
            <tr>
              <td>Allowable Stress at Design Temperature (t)</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.tensaoAdmissivelBocal }}
                </h6>
              </td>
            </tr>
            <tr>
              <td>Minimum Required Thickness (Without Corrosion Allowance)</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.espessuraMinimaBocal }}
                </h6>
              </td>
            </tr>
            <tr>
              <td>Nominal Thickness</td>
              <td><input class="form-control" v-model="bocalCalculator.espessuraNominalBocal" type="number" step="any" required/></td>
            </tr>
            <tr>
              <td>Corroded Thickness (Nominal Thickness - Corrosion Allowance)</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.espessuraCorroidaBocal }}
                </h6>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- 5. LIMITES UG-41 -->
      <h5 class="text mt-5 text-primary"><b>5. Limits acc. to UG-41</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">
          <thead>
            <tr>
              <th colspan="4" class="text-center bg-light">UG-41, Dimensional Limits for reinforcement </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="2" class="fw-bold">DL = The highest value of</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td class="text-end">2(d + 2Can)</td>
              <td>mm</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.calculo2dMais2Can }}
                </h6>
              </td>
              <td>
                <h6 class="text my-auto">
                  DL: {{ bocalCalculator.DL }}
                </h6>
              </td>
            </tr>
            <tr>
              <td class="text-end">2(Rn + tn + tv)</td>
              <td>mm</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.calculo2RnMaisTnMaisTv }}
                </h6>
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="2" class="fw-bold pt-4">TLNP = The lowest value of</td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td class="text-end">2,5tv</td>
              <td>mm</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.calculo2ponto5Tv }}
                </h6>
              </td>
              <td>
                <h6 class="text my-auto">
                  TLNP: {{ bocalCalculator.TLNP }}
                </h6>
              </td>
            </tr>
            <tr>
              <td class="text-end">2,5tn + (te)</td>
              <td>mm</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.calculo2ponto5TnMaisTe }}
                </h6>
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="fw-bold pt-4">Ratio between Sn/Sv</td>
              <td>fr1</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.razaoSnSv }}
                </h6>
              </td>
              <td>Coef.</td>
            </tr>
            <tr>
              <td class="fw-bold">Smallest among Sn/Sv e Sr/Sv</td>
              <td>fr2</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.menorSnSvSrSv }}
                </h6>
              </td>
              <td>Coef.</td>
            </tr>
            <tr>
              <td class="fw-bold">Ratio Se/Sv</td>
              <td>fr3</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.razaoSeSv }}
                </h6>
              </td>
              <td>Coef.</td>
            </tr>
            <tr>
              <td><span><b>Correction factor to compensate for angulation concerning the axial axis FIG.UG-37</b></span>
                <InterrogacaoHover text="Fator que corrige o efeito de inclinação do bocal em relação ao eixo do vaso, conforme FIG UG-37." />
              </td>
            </tr>
            <tr>
              <td><b>F</b></td>
              <td><input class="form-control" v-model="bocalCalculator.fatorCorrecao" type="number" step="any" required/></td>
              <td><b>Coef.</b></td>
            </tr>
          </tbody>
        </table>

      </div>
      
      <!-- 6. ÁREAS DE REFORÇO -->
      <h5 class="text mt-5 text-primary"><b>6. REINFORCEMENT AREAS</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">
          <tbody>
            <tr>
              <td>Available reinforcement area in the shell: use the greater of</td>
              <td>AR</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.areaRequerida }}
                </h6>
              </td>
              <td>mm²</td>
            </tr>
            <tr>
              <td>Available reinforcement area in the nozzle: use the lesser of</td>
              <td>A1</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.A1 }}
                </h6>
              </td>
              <td>mm²</td>
            </tr>
            <tr>
              <td>Weld Areas</td>
              <td>A2</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.A2 }}
                </h6>
              </td>
              <td>mm²</td>
            </tr>
            <tr>
              <td>Área da solda externa (2-2)
                <InterrogacaoHover text="A41 - Type the throat of the outward weld between the pad and nozzle or shell and nozzle." />
              </td>
              <td>A41</td>
              <td><input class="form-control" v-model="bocalCalculator.extBocalCostPad" type="number" step="any" required/></td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.areaSoldaExterna }}
                </h6>
              </td>
              <td>mm²</td>
            </tr>
            <tr>
              <td>Área da solda da chapa/costado (1-1)
                <InterrogacaoHover text="A42 - Type the value of the outer weld leg around the pad." />
              </td>
              <td>A42</td>
              <td><input class="form-control" v-model="bocalCalculator.padCostado" type="number" step="any" required/></td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.areaSoldaPadCostado }}
                </h6>
              </td>
              <td>mm²</td>
            </tr>
            <tr>
              <td>Área da solda interna (3-3)
                <InterrogacaoHover text="A43 - Type the inward weld leg of the projection." />
              </td>
              <td>A43</td>
              <td><input class="form-control" v-model="bocalCalculator.intBocalCost" type="number" step="any" required/></td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.areaSoldaInterna }}
                </h6>
              </td>
              <td>mm²</td>
            </tr>
            <tr>
              <td>Area of the nozzle that penetrates the shell
                <InterrogacaoHover text="Area available in inward nozzle" />
              </td>
              <td>A3</td>
              <td><input class="form-control" v-model="bocalCalculator.h" type="number" step="any" required/></td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.areaBocalPenetraCasco }}
                </h6>
              </td>
              <td>mm²</td>
            </tr>
            <tr>
              <td>Reinforcing plate area</td>
              <td>A5</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.areaChapaReforco }}
                </h6>
              </td>
              <td>mm²</td>
            </tr>
            <tr>
              <td><b>Total reinforcement area</b></td>
              <td>AT</td>
              <td>
                <h6 class="text my-auto">
                  <b>{{ bocalCalculator.areaTotalReforco }}</b>
                </h6>
              </td>
              <td>mm²</td>
              <td>
              <h6 clas="text my-auto"> 
                <b>{{ bocalCalculator.resultadoRefoço }}</b>
              </h6>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- 7. RESULTADO -->
      <h5 class="text mt-5 text-primary"><b>7. RESULT</b></h5>

      <div class="mt-5 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3">
        <h4 class="mb-0">
          <b>Calculation Results:</b>
        </h4>

        <span
          v-if="bocalCalculator.validNominalThickness"
          class="badge bg-success fs-6 px-3 py-2"
        >
          <b>✔ Nominal Thickness Valid</b>
        </span>

        <span
          v-else
          class="badge bg-danger fs-6 px-3 py-2"
        >
          <b>✖ Nominal Thickness Not Valid</b>
        </span>
      </div>

      <div class="text-center mt-2">
        <b>{{ bocalCalculator.resultado }}</b>
      </div>

      <!-- 8. CARGAS NA SOLDA - UG-41 -->
      <h5 class="text mt-5 text-primary"><b>8. WELD LOADS - UG-41 SKETCH (a) or (b)</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">
          <tbody>
            <tr>
              <td>Total Load on Welds</td>
              <td>F</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.cargaTotalSoldas }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Weld Load on Failure Line 1-1 - w1=(A2+A5+A41+A42)*Sv</td>
              <td>F1</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.cargaLinhaFalha11 }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Weld Load on Failure Line 2-2 - w2=(A2+A3+A41+A43+2*tn*tv*fr1)*Sv</td>
              <td>F2</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.cargaLinhaFalha22 }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Weld Load on Failure Line 3-3 - w3=(A2+A3+A5+A41+A42+A43+2*tn*tv*fr1)*Sv</td>
              <td>F3</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.cargaLinhaFalha33 }}
                </h6>
              </td>
              <td>N</td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- 9. RESISTÊNCIA DOS ELEMENTOS DE CONEXÃO -->
      <h5 class="text mt-5 text-primary"><b>9. RESISTANCE OF CONNECTING ELEMENTS IN FAULT LINES</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">
          <tbody>
            <tr>
              <td>Allowable stress for welds based on the weaker material between the nozzle, shell, and reinforcement pad</td>
              <td>S</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.tensaoAdmissivelSoldas }}
                </h6>
              </td>
              <td>N/mm²</td>
            </tr>
            <tr>
              <td>Shear Stress, Weld Nozzle / Pad or Shell (leg2) - 0,5*PI*dbo*L2*Sw2</td>
              <td>R2</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.cisalhamentoSoldaBocalPad }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Tensile Stress, weld PAD/Shel (leg1) - 0,5*PI*Dp*L1*Sw1</td>
              <td>R1</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.cisalhamentoSoldaPadCasco }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Tension, Butt weld, PAD/Shell - 0,5*PI*Dp*L1*Sw1</td>
              <td>R3</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.tracaoSoldaTopoPadCasco }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Tension, Butt weld, Shell/Nozzle - 0,5*3,1416*dbo*tv*Sw4</td>
              <td>R4</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.tracaoSoldaTopoCascoBocal }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>At the nozzle - 0,5*3,1416*dbm*tb*Snozzle</td>
              <td>R5</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resistenciaBocal }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>At the Reinforcement PAD - A5*Spad (Spad=Se)</td>
              <td>R6</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resistenciaChapaReforco }}
                </h6>
              </td>
              <td>N</td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- 10. RESISTÊNCIA DAS LINHAS DE FALHA -->
      <h5 class="text mt-5 text-primary"><b>10. FAILURE LINE STRENGTH</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">
          <tbody>
            <tr>
              <td>LINHA 1-1 R11 = R1+R2+R5</td>
              <td>R11</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resistenciaLinha11 }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Comparação: R11 > máximo(F, F1)</td>
              <td>Resultado 1-1</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resultadoLinha11 }}
                </h6>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>LINHA 2-2 R22 = R2+R3+R4</td>
              <td>R22</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resistenciaLinha22 }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Comparação: R22 > máximo(F, F2)</td>
              <td>Resultado 2-2</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resultadoLinha22 }}
                </h6>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>LINHA 3-3 R33 = R1+R2+R4</td>
              <td>R33</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resistenciaLinha33 }}
                </h6>
              </td>
              <td>N</td>
            </tr>
            <tr>
              <td>Comparação: R33 > máximo(F, F3)</td>
              <td>Resultado 3-3</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resultadoLinha33 }}
                </h6>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>AT THE REINFORCEMENT PAD R1 > R6</td>
              <td>Resultado Chapa</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.resultadoChapaReforco }}
                </h6>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- 11. FLANGE DATA -->
      <h5 class="text mt-5 text-primary"><b>11. FLANGE DATA</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">

          <tbody>
            <tr>
              <td>Material Flange</td>
              <td></td>
              <td>
                <select class="form-select" v-model="bocalCalculator.materialFlange" required>
                  <option disabled value="">Selecione</option>
                  <option
                    v-for="material in materiaisFlange"
                    :key="material"
                    :value="material"
                  >
                    {{ material }}
                  </option>
                </select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>Pressure Rating</td>
              <td></td>
              <td>
                <select class="form-select" v-model="bocalCalculator.pressureRating" required>
                  <option disabled value="">Selecione</option>
                  <option
                    v-for="rating in pressureRatings"
                    :key="rating"
                    :value="rating"
                  >
                    {{ rating }}
                  </option>
                </select>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>WAMP (MPa)</td>
              <td></td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.wamp }}
                </h6>
              </td>
              <td></td>
            </tr>

          </tbody>
        </table>

      </div>

      <!-- 12. MINIMUM NOZZLE THICKNESS ACC. TO UG-45 -->
      <h5 class="text mt-5 text-primary"><b>12. MINIMUM NOZZLE THICKNESS ACC. TO UG-45</b></h5>

      <div class="table-responsive">

        <table class="table mt-3">

          <tbody>
            <tr>
              <td>DESIGN PRESSURE </td>
              <td>P</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.pressaoProjeto }}
                </h6>
              </td>
              <td>MPa</td>
            </tr>
            <tr>
              <td>ADMISSIBLE STRESS  </td>
              <td>S</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.tensaoAdmissivelBocal }}
                </h6>
              </td>
              <td>MPa</td>
            </tr>
            <tr>
              <td>NOMINAL DIAMETER NOZZLE (NPS)</td>
              <td>Dn</td>
              <td>
                <select class="form-select" v-model="bocalCalculator.nominalDiameterNozzle" required>
                  <option disabled value="">Selecione</option>
                  <option
                      v-for="nominal in nominalOptions"
                      :key="nominal.name"
                      :value="nominal"
                  >
                      {{ nominal.nominalDiameter }}
                  </option>
                  
                </select>
              </td>
              <td>Inches</td>
            </tr>
            <tr>
              <td>Alerta Dimensional do bocal </td>
              <td></td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.alertaErrdimensionalBocal }}
                </h6>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>EXTERNAL DIAMETER NOZZLE </td>
              <td>De</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.externalRadiusNozzle }}
                </h6>
              </td>
              <td>mm</td>
            </tr>
            <tr>
              <td>WELDED JOINT EFFICIENCY </td>
              <td>E</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.eficienciaJuntaBocal }}
                </h6>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>CORROSION ALLOWANCE </td>
              <td>CA</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.corrosaoAdmissivelBocal }}
                </h6>
              </td>
              <td>mm</td>
            </tr>
            <tr>
              <td>THICKNESS (ta) </td>
              <td>ta</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.thicknessTa }}
                </h6>
              </td>
              <td>mm</td>
            </tr>
            <tr>
              <td>UG-45 </td>
              <td></td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.ug45 }}
                </h6>
              </td>
              <td>mm</td>
            </tr>
            <tr>
              <td>MINIMUM THICKNESS ACC. UG-45 (Max. (ta;tb))</td>
              <td>t (UG-45)</td>
              <td>
                <h6 class="text my-auto">
                  {{ bocalCalculator.minThicknessUG45 }}
                </h6>
              </td>
              <td>mm</td>
            </tr>
          </tbody>
        </table>

      </div>

      <!-- Drawing -->
      <div class="form-group calculator-drawing bocal-desenho row">
          <div class="calculator-drawing-title">Drawing</div>
          <div class="col d-flex justify-content-center">
            <div class="calculator-drawing-frame flex-column w-100">
              <img src="../img/calculator-bocal/drawing-bocal.png" width="300px" alt="Image of Drawing" class="calculator-drawing-image img-drawing-bocal">
              <img src="../img/calculator-bocal/legenda-bocal-recortada.png" width="500px" alt="Image of Legend" class="calculator-drawing-image img-legenda-drawing-bocal">
            </div>
          </div>
      </div>

    </form>
  </div>
</template>

<script>
import DatabaseThickPlateASTM_A20 from "@/models/database/DatabaseThickPlateASTM_A20.js";
import arrayMateriaisASMEII from "../../../../backend/src/database/asmeii/arrayMateriaisASMEII.js";
import arrayTabelaClasseFlangeBocais from "../../../../backend/src/database/asmeii/arrayTabelaClasseFlangeBocais.js";
import arrayNominalDiameterNozzle from "@/models/database/NominalDiameterNozzle.js";
import InterrogacaoHover from "../../componentesTelas/InterrogacaoHover.vue";
import DesenhoApoio from "../../componentesTelas/DesenhoApoio.vue";

export default {
    name: "BocalCalculatorComponent",
    props: {
        bocalCalculatorProps: {
            type: Object,
            required: true,
        },
        designData: {
            type: Object,
            required: true,
        },
    },
    components: {
        InterrogacaoHover,
        DesenhoApoio
    },
    data() {
        return {
            bocalCalculator: this.bocalCalculatorProps,
            nominalThicknessOptions: [],

            // BUSCA MATERIAL
            materialSpecificationOptions: [],
            materialSearch: "",
            mostrarListaMaterial: false,
            debounceTimeout: null,

            // Array para armazenar os diâmetros nominais do bocal
            nominalOptions: [],

            // EXIBIR DESENHO DE APOIO
            showDrawing: false,
        };
    },
    mounted() {
      this.$nextTick(() => {
        this.calculos();
      });
    },

    watch: {
        // Seta o valor do material no campo de busca
        'bocalCalculator.materialSpecification': {
            immediate: true,
            deep: true,
            handler(material) {
            if (
                material &&
                typeof material === 'object' &&
                material.materialSpecification
            ) {
                this.materialSearch = material.materialSpecification;
                // this.calculos();
            }
            }
        },

        'bocalCalculator.nominalDiameterNozzle': {
          immediate: true,
          handler(diameter) {
            if (!diameter) {
              this.bocalCalculator.externalRadiusNozzle = null;
              this.bocalCalculator.externalDiameterNozzle = null;
              this.bocalCalculator.espessuraMinimaBocal = null;
              return;
            }

            const option = this.nominalOptions.find(
              item => item.nominalDiameter === diameter.nominalDiameter
            );
            if (option && option !== diameter) {
              this.bocalCalculator.nominalDiameterNozzle = option;
              return;
            }

            // Preenche o valor de externalRadiusNozzle
            this.bocalCalculator.externalRadiusNozzle = diameter.externalDiameter;
            this.bocalCalculator.ug45 = diameter.minThicknessMm + this.converterParaFloat(this.bocalCalculator.corrosaoAdmissivelBocal);

            // Executa todos os cálculos
            this.$nextTick(() => {
              this.calculos();
            });
          }
        },

        // Calcular WAMP
        'bocalCalculator.materialFlange': 'calcularWamp',
        'bocalCalculator.pressureRating': 'calcularWamp',
        'bocalCalculator.temperaturaReferencia': 'calcularWamp'

    },
    computed: {
        // Lista de materiais filtrados
        materiaisFiltrados() {
            const termo = this.materialSearch.toLowerCase().trim();
            
            let resultados;
            
            if (!termo) {
                resultados = this.materialSpecificationOptions;
            } else {
                resultados = this.materialSpecificationOptions.filter(mat => {
                    const materialName = mat.materialSpecification?.toLowerCase() || '';
                    return materialName.includes(termo);
                });
            }
            
            // ORDENAÇÃO GARANTIDA - por materialSpecification em ordem crescente
            const resultadosOrdenados = [...resultados].sort((a, b) => {
                const nameA = (a.materialSpecification || '').toString();
                const nameB = (b.materialSpecification || '').toString();
                
                // Extrai números dos nomes para ordenação numérica apropriada
                const numMatchA = nameA.match(/\d+/g);
                const numMatchB = nameB.match(/\d+/g);
                
                // Se ambos têm números, ordena numericamente
                if (numMatchA && numMatchB) {
                    // Compara o primeiro número encontrado
                    const numA = parseInt(numMatchA[0]);
                    const numB = parseInt(numMatchB[0]);
                    
                    if (numA !== numB) {
                        return numA - numB;
                    }
                }
                
                // Fallback para ordenação alfabética com localeCompare
                return nameA.localeCompare(nameB, undefined, { 
                    numeric: true,
                    sensitivity: 'base'
                });
            });
            
            return resultadosOrdenados;
        },

        materiaisFlange() {
          const materiais = arrayTabelaClasseFlangeBocais.map(i => i.material);
          return [...new Set(materiais)].sort();
        },

        pressureRatings() {
          const classes = arrayTabelaClasseFlangeBocais.map(i => i.pressureClass);
          return [...new Set(classes)].sort();
        },

        espessuraMinimaCascoCalculada() {
          const espessuraMinima = this.converterParaFloat(this.bocalCalculator.espessuraMinimaCasco);
          const eficiencia = this.converterParaFloat(this.bocalCalculator.eficienciaJuntaCasco);

          return this.bocalCalculator.soldaCostado === "1"
            ? espessuraMinima * eficiencia
            : espessuraMinima;
        }
    },

    created() {
        const database1 = new DatabaseThickPlateASTM_A20();
        this.nominalThicknessOptions = database1.nominalThickness;

        // Array para armazenar os diâmetros nominais do bocal
        this.nominalDiameterNozzleArray = new arrayNominalDiameterNozzle();

        this.nominalOptions = this.nominalDiameterNozzleArray.arrayNominalDiameterNozzle;

        // Carrega e ORDENA os materiais em ordem crescente
        this.carregarMateriaisOrdenados();
    },

    methods: {

        // CONTROLES DO DESENHO DE APOIO
        mostrarDesenho() {
            if(this.showDrawing === false){
                this.showDrawing = true;
            }
            else{
                this.showDrawing = false;
            }            
        },

        // CONTROLE DA IMAGEM FLUTUANTE
        startDrag(e) {
            this.dragging = true
            this.offsetX = e.clientX - this.posX
            this.offsetY = e.clientY - this.posY

            document.addEventListener('mousemove', this.onDrag)
            document.addEventListener('mouseup', this.stopDrag)
        },

        onDrag(e) {
            if (!this.dragging) return
            this.posX = e.clientX - this.offsetX
            this.posY = e.clientY - this.offsetY
        },

        stopDrag() {
            this.dragging = false
            document.removeEventListener('mousemove', this.onDrag)
            document.removeEventListener('mouseup', this.stopDrag)
        },

        abrirListaMaterial() {
            this.mostrarListaMaterial = true;
        },

        fecharListaMaterial() {
            setTimeout(() => {
            this.mostrarListaMaterial = false;
            }, 150);
        },

        // Método para carregar e ordenar materiais
        carregarMateriaisOrdenados() {
            if (Array.isArray(arrayMateriaisASMEII)) {
                // Ordena os materiais pelo materialSpecification em ordem crescente
                this.materialSpecificationOptions = arrayMateriaisASMEII
                    .slice() // Cria uma cópia
                    .sort((a, b) => {
                        const materialA = a.materialSpecification || '';
                        const materialB = b.materialSpecification || '';
                        
                        // Extrai números para ordenação numérica
                        const numMatchA = materialA.match(/\d+/g);
                        const numMatchB = materialB.match(/\d+/g);
                        
                        if (numMatchA && numMatchB) {
                            const numA = parseInt(numMatchA[0]);
                            const numB = parseInt(numMatchB[0]);
                            
                            if (numA !== numB) {
                                return numA - numB;
                            }
                        }
                        
                        // Ordenação alfabética para strings sem números ou números iguais
                        return materialA.localeCompare(materialB, undefined, { 
                            numeric: true,
                            sensitivity: 'base'
                        });
                    });

                } 
                else {
                console.error('arrayMateriaisASMEII não é um array válido');
                this.materialSpecificationOptions = [];
            }
        },

        // Método para lidar com input enquanto digita
        handleInput() {
            // Limpa timeout anterior
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            
            // Abre a lista imediatamente quando começa a digitar
            if (this.materialSearch.trim() !== '' && !this.mostrarListaMaterial) {
                this.mostrarListaMaterial = true;
            }
            
            // Se apagou tudo, fecha a lista
            if (this.materialSearch.trim() === '') {
                this.mostrarListaMaterial = false;
                return;
            }
            
            // Configura novo timeout para garantir que a lista fique aberta
            this.debounceTimeout = setTimeout(() => {
                if (this.materialSearch.trim() !== '') {
                    this.mostrarListaMaterial = true;
                }
            }, 100);
        },

        selecionarMaterial(material) {
            this.bocalCalculator.materialSpecification = material;
            this.materialSearch = material.materialSpecification;
            this.mostrarListaMaterial = false;

            // Busca a tensão admissível para o material e temperatura selecionados
            this.bocalCalculator.tensaoAdmissivelBocal = this.buscarCampoAdmissibleStressDatabaseASMEII(
                this.bocalCalculator.materialSpecification,
                this.bocalCalculator.temperaturaProjeto
            );

            // this.calculos();
        },

        verificarLimiteDL() {
          const diametro = this.converterParaFloat(this.bocalCalculator.diametroChapaReforco);
          const pad = this.converterParaFloat(this.bocalCalculator.padCostado);
          const dl = this.converterParaFloat(this.bocalCalculator.DL);

          return diametro + (2 * pad) <= dl;
        },

        calcularWamp() {
          const material = this.bocalCalculator.materialFlange;
          const pressure = this.bocalCalculator.pressureRating;
          const temp = this.bocalCalculator.temperaturaReferencia;

          if (!material || !pressure || !temp) {
            this.bocalCalculator.wamp = null;
            return;
          }

          const item = arrayTabelaClasseFlangeBocais.find(
            el =>
              el.material === material &&
              el.pressureClass === pressure
          );

          if (!item) {
            this.bocalCalculator.wamp = null;
            return;
          }

          // 🔥 pega o valor direto
          const wamp = item.data?.[String(temp)];

          this.bocalCalculator.wamp = wamp ?? null;

        },

        buscarCampoAdmissibleStressDatabaseASMEII(materialSpecification, chaveGrausCelsiusBuscada) {

            if (!materialSpecification || !materialSpecification.rangeDesignTemperatureCelsius) {
                console.warn("Material ou rangeDesignTemperatureCelsius não encontrado");
                return null;
            }

            const tabela = materialSpecification.rangeDesignTemperatureCelsius;

            // 🔹 normaliza a chave buscada
            let chaveNormalizada = chaveGrausCelsiusBuscada;

            if (typeof chaveNormalizada === "string" && chaveNormalizada.includes(",")) {
                chaveNormalizada = chaveNormalizada.replace(",", ".");
            }

            const chaveBuscada = parseFloat(chaveNormalizada);


            // 🔹 se existir valor exato
            if (tabela[chaveNormalizada] !== undefined) {
                return parseFloat(tabela[chaveNormalizada]);
            }

            // 🔹 preparar temperaturas numéricas
            const temperaturasStr = Object.keys(tabela);
            const temperaturasNum = temperaturasStr
                .map(t => parseFloat(t.replace(",", ".")))
                .sort((a, b) => a - b);

            if (chaveBuscada < temperaturasNum[0] || chaveBuscada > temperaturasNum[temperaturasNum.length - 1]) {
              this.$emit("temperatura-fora-faixa", {
                temperatura: chaveBuscada,
                minimo: temperaturasNum[0],
                maximo: temperaturasNum[temperaturasNum.length - 1],
              });
              return null;
            }

            const temperaturaExata = temperaturasStr.find(
              t => parseFloat(t.replace(",", ".")) === chaveBuscada
            );

            if (temperaturaExata !== undefined) {
              return parseFloat(tabela[temperaturaExata]);
            }

            // 🔹 encontrar anterior e posterior
            const indicePosterior = temperaturasNum.findIndex(t => t > chaveBuscada);
            const indiceAnterior = indicePosterior > 0 ? indicePosterior - 1 : -1;

            if (indiceAnterior < 0 || indicePosterior === -1) {
                console.warn("Temperatura fora do range do material");
              this.$emit("temperatura-fora-faixa", {
                temperatura: chaveBuscada,
                minimo: temperaturasNum[0],
                maximo: temperaturasNum[temperaturasNum.length - 1],
              });
                return null;
            }

            const tempAnterior = temperaturasNum[indiceAnterior];
            const tempPosterior = temperaturasNum[indicePosterior];

            const chaveAnteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempAnterior
            );
            const chavePosteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempPosterior
            );

            const valorAnterior = parseFloat(tabela[chaveAnteriorStr]);
            const valorPosterior = parseFloat(tabela[chavePosteriorStr]);

            // 🔹 interpolação linear (mesma lógica do backend)
            const fator =
              (chaveBuscada - tempAnterior) /
              (tempPosterior - tempAnterior);

            const interpolado =
              valorAnterior + (valorPosterior - valorAnterior) * fator;

            return interpolado.toFixed(2);

            // return Number(interpolado.toFixed(3));
        },
 
        async calculos() {

          if (this.$refs.formCalculo && !this.$refs.formCalculo.reportValidity()) {
            return;
          }
           
          // Validação dos campos obrigatórios do formulário
          // const form = this.$refs.formCalculo;

          // if (!form.checkValidity()) {
          //   form.reportValidity();
          //   return;
          // }

          //Conversões
          this.bocalCalculator.diametroInternoAbertura = this.converterParaFloat(this.bocalCalculator.diametroInternoAbertura);
          this.bocalCalculator.diametroInternoCasco = this.converterParaFloat(this.bocalCalculator.diametroInternoCasco);
          this.bocalCalculator.eficienciaJuntaBocal = this.converterParaFloat(this.bocalCalculator.eficienciaJuntaBocal);
          this.bocalCalculator.eficienciaJuntaCasco = this.converterParaFloat(this.bocalCalculator.eficienciaJuntaCasco);
          this.bocalCalculator.corrosaoAdmissivelBocal = this.converterParaFloat(this.bocalCalculator.corrosaoAdmissivelBocal);
          this.bocalCalculator.corrosaoAdmissivelCasco = this.converterParaFloat(this.bocalCalculator.corrosaoAdmissivelCasco);
          this.bocalCalculator.espessuraNominalCasco = this.converterParaFloat(this.bocalCalculator.espessuraNominalCasco);
          this.bocalCalculator.espessuraNominalBocal = this.converterParaFloat(this.bocalCalculator.espessuraNominalBocal);
          this.bocalCalculator.espessuraChapaReforco = this.converterParaFloat(this.bocalCalculator.espessuraChapaReforco);
          this.bocalCalculator.tensaoAdmissivelChapaReforco = this.converterParaFloat(this.bocalCalculator.tensaoAdmissivelChapaReforco);
          this.bocalCalculator.diametroChapaReforco = this.converterParaFloat(this.bocalCalculator.diametroChapaReforco);
          // this.bocalCalculator.tensaoAdmissivelCasco = this.converterParaFloat(this.bocalCalculator.tensaoAdmissivelCasco);
          this.bocalCalculator.extBocalcostPad = this.converterParaFloat(this.bocalCalculator.extBocalCostPad);

          this.bocalCalculator.validNominalThickness = this.bocalCalculator.espessuraNominalCasco >= this.espessuraMinimaCascoCalculada;

          //Dados do Projeto
          //Project Pressure

          //Eficiencias e Corrosão
          //Internal Radius of Corroded Nozzle
          this.bocalCalculator.raioInternoBocalCorroido = this.converterParaFloat(((this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.corrosaoAdmissivelBocal)/2).toFixed(3));
          //=(G22+2*G26)/2
          
          //Dados Materiais Casco
          //Tensao Admissivel Casco -- A definir
          //espessura minima casco
          // this.bocalCalculator.espessuraMinimaCasco = 28.02;
          //espessura corroida casco
          this.bocalCalculator.espessuraCorroidaCasco = this.converterParaFloat((this.bocalCalculator.espessuraNominalCasco - this.bocalCalculator.corrosaoAdmissivelCasco).toFixed(3));

          //Dados Materiais Bocal
          //Tensao Admissivel Bocal -- A definir

          //espessura corroida bocal
          this.bocalCalculator.espessuraCorroidaBocal = this.converterParaFloat((this.bocalCalculator.espessuraNominalBocal - this.bocalCalculator.corrosaoAdmissivelBocal).toFixed(3));

          //Thickness
          // =E134*0,5*E137/(E135*E138+0,4*E134)+E139
          this.bocalCalculator.thicknessTa = this.converterParaFloat(((this.bocalCalculator.pressaoProjeto * 0.5 * this.bocalCalculator.externalRadiusNozzle) / (this.bocalCalculator.tensaoAdmissivelBocal * this.bocalCalculator.eficienciaJuntaBocal + 0.4 * this.bocalCalculator.pressaoProjeto) + this.bocalCalculator.corrosaoAdmissivelBocal).toFixed(2));

          //Minimun tickness acc. UG-45
          //=MÁXIMO(E140;E141)
          this.bocalCalculator.minThicknessUG45 = 0;
          this.bocalCalculator.minThicknessUG45 = this.converterParaFloat(Math.max(this.bocalCalculator.thicknessTa, this.bocalCalculator.ug45).toFixed(3));

          this.bocalCalculator.espessuraMinimaBocal = this.bocalCalculator.minThicknessUG45;

          //LIMITES UG-41
          this.bocalCalculator.calculo2RnMaisTnMaisTv = this.converterParaFloat((2 * (this.bocalCalculator.raioInternoBocalCorroido + this.bocalCalculator.espessuraCorroidaBocal + this.bocalCalculator.espessuraCorroidaCasco)).toFixed(2));
          this.bocalCalculator.calculo2dMais2Can = this.converterParaFloat((2 * (this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.corrosaoAdmissivelBocal)).toFixed(2));
          //DL
          this.bocalCalculator.DL = this.converterParaFloat((Math.max(
            this.bocalCalculator.calculo2dMais2Can,
            this.bocalCalculator.calculo2RnMaisTnMaisTv
          )).toFixed(2));

          //TLNP
          this.bocalCalculator.calculo2ponto5Tv = this.converterParaFloat((2.5 * this.bocalCalculator.espessuraCorroidaCasco).toFixed(2));
          this.bocalCalculator.calculo2ponto5TnMaisTe = this.converterParaFloat((2.5 * this.bocalCalculator.espessuraCorroidaBocal + this.bocalCalculator.espessuraChapaReforco).toFixed(2));

          //TLNP
          this.bocalCalculator.TLNP = this.converterParaFloat((Math.min(
            this.bocalCalculator.calculo2ponto5Tv,
            this.bocalCalculator.calculo2ponto5TnMaisTe
          )).toFixed(2));

          //Razao Sn/Sv
          this.bocalCalculator.razaoSnSv = this.converterParaFloat((Math.min((this.bocalCalculator.tensaoAdmissivelBocal / this.bocalCalculator.tensaoAdmissivelCasco), 1)).toFixed(3));

          //Menor Sn/Sv e Sr/Sv
          this.bocalCalculator.menorSnSvSrSv = this.converterParaFloat((Math.min(
            this.bocalCalculator.razaoSnSv,
            (this.bocalCalculator.tensaoAdmissivelChapaReforco / this.bocalCalculator.tensaoAdmissivelCasco)
          )).toFixed(3));

          //Razao Se/Sv
          this.bocalCalculator.razaoSeSv = this.converterParaFloat((this.bocalCalculator.tensaoAdmissivelChapaReforco / this.bocalCalculator.tensaoAdmissivelCasco).toFixed(3));


          //Áreas de Reforço

          //A1
          //=(I43-(G23+2*G27))*((G26*E40)-(H51*E38))-(2*H40*(G26*E40-(H51*E38))*(1-H48))
          this.bocalCalculator.A1formula1 = this.converterParaFloat(((this.bocalCalculator.DL - (this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.corrosaoAdmissivelBocal))
            * ((this.bocalCalculator.eficienciaJuntaCasco * this.bocalCalculator.espessuraCorroidaCasco) - (this.bocalCalculator.fatorCorrecao * this.espessuraMinimaCascoCalculada))
            - (2 * this.bocalCalculator.espessuraCorroidaBocal * (this.bocalCalculator.eficienciaJuntaCasco * this.bocalCalculator.espessuraCorroidaCasco - (this.bocalCalculator.fatorCorrecao * this.espessuraMinimaCascoCalculada)) * (1 - this.bocalCalculator.razaoSnSv))).toFixed(3));

          this.bocalCalculator.A1formula2 = this.converterParaFloat(
            (2 * (this.bocalCalculator.espessuraCorroidaCasco + this.bocalCalculator.espessuraCorroidaBocal) * (this.bocalCalculator.eficienciaJuntaCasco * this.bocalCalculator.espessuraCorroidaCasco - this.bocalCalculator.fatorCorrecao * this.espessuraMinimaCascoCalculada)
            - 2 * this.bocalCalculator.espessuraCorroidaBocal * (this.bocalCalculator.eficienciaJuntaCasco * this.bocalCalculator.espessuraCorroidaCasco - this.bocalCalculator.fatorCorrecao * this.espessuraMinimaCascoCalculada) * (1 - this.bocalCalculator.razaoSnSv)).toFixed(3));

          this.bocalCalculator.A1 =this.converterParaFloat(Math.max(this.bocalCalculator.A1formula1, this.bocalCalculator.A1formula2).toFixed(2));
          
          //A2
          //Formula 1
          this.bocalCalculator.A2formula1 = this.converterParaFloat(((this.bocalCalculator.espessuraCorroidaBocal - this.bocalCalculator.espessuraMinimaBocal)
                                            * this.bocalCalculator.razaoSnSv * 2 * this.bocalCalculator.calculo2ponto5Tv).toFixed(3));
          //=(H40-H38)
          // *H48*2*G46
          //Formula 2
          //=(H40-H38)*2*(G47)*H48
          this.bocalCalculator.A2formula2 = this.converterParaFloat(((this.bocalCalculator.espessuraCorroidaBocal - this.bocalCalculator.espessuraMinimaBocal)
                                            * 2 * this.bocalCalculator.calculo2ponto5TnMaisTe * this.bocalCalculator.razaoSnSv).toFixed(3));
          //=SE(F57<F56;F57;F56)
          this.bocalCalculator.A2 = this.converterParaFloat(Math.min(this.bocalCalculator.A2formula1, this.bocalCalculator.A2formula2).toFixed(2));
          
          //Areas de Solda
          //A41
          //=E58^2 * H49
          this.bocalCalculator.areaSoldaExterna = this.converterParaFloat((Math.pow(this.bocalCalculator.extBocalcostPad, 2) * this.bocalCalculator.menorSnSvSrSv).toFixed(3));
          //A42
          //=E59^2*H49
          this.bocalCalculator.areaSoldaPadCostado = this.converterParaFloat((Math.pow(this.bocalCalculator.padCostado, 2) * this.bocalCalculator.menorSnSvSrSv).toFixed(3));
          //A43
          //=E60^2*H48
          this.bocalCalculator.areaSoldaInterna = this.converterParaFloat((Math.pow(this.bocalCalculator.intBocalCost, 2) * this.bocalCalculator.razaoSeSv).toFixed(3));

          //Area do bocal que penetra no casco|
          //A3
          //=2*E62*H40
          this.bocalCalculator.areaBocalPenetraCasco = this.converterParaFloat((2 * this.bocalCalculator.h * this.bocalCalculator.espessuraCorroidaBocal).toFixed(3));

          //Area da chapa de reforco
          //A5
          //=(G32-G23-2*H39)*G30
          this.bocalCalculator.areaChapaReforco = this.converterParaFloat(((this.bocalCalculator.diametroChapaReforco - this.bocalCalculator.diametroInternoAbertura - 2 * this.bocalCalculator.espessuraNominalBocal) * this.bocalCalculator.espessuraChapaReforco).toFixed(3));

          //Area requerida
          //=(G23+2*G27)*E38*H51+(2*H40*E38*(1-H48)*H51)
          this.bocalCalculator.areaRequerida = this.converterParaFloat(((this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.corrosaoAdmissivelBocal) * this.espessuraMinimaCascoCalculada * this.bocalCalculator.fatorCorrecao + (2 * this.bocalCalculator.espessuraCorroidaBocal * this.espessuraMinimaCascoCalculada * (1 - this.bocalCalculator.razaoSnSv) * this.bocalCalculator.fatorCorrecao)).toFixed(3));

          //Area total de reforco
          //=H54+H56+H58+H59+H60+H62+H65
          this.bocalCalculator.areaTotalReforco = this.converterParaFloat((this.bocalCalculator.A1 + this.bocalCalculator.A2 + this.bocalCalculator.areaSoldaExterna + this.bocalCalculator.areaSoldaPadCostado + this.bocalCalculator.areaSoldaInterna + this.bocalCalculator.areaBocalPenetraCasco + this.bocalCalculator.areaChapaReforco).toFixed(3));
          //=SE(F70>H67;"OK,Aprovado!";"REFORÇAR")
          this.bocalCalculator.resultadoRefoço = this.bocalCalculator.areaTotalReforco > this.bocalCalculator.areaRequerida ? "ok, Approved!" : "REFORÇAR";

          //Carga total nas Soldas
          //=SE((((H67-H54)+(2*H40*H48*((G26*(E40))-E38)))*E37)>0;(((H67-H54)+(2*H40*H48*((G26*(E40))-E38)))*E37);0)
          //this.bocalCalculator.cargaTotalSoldas = this.converterParaFloat(((((this.bocalCalculator.areaRequerida - this.bocalCalculator.A1) + (2 * this.bocalCalculator.espessuraCorroidaBocal * this.bocalCalculator.razaoSnSv * ((this.bocalCalculator.eficienciaJuntaCasco * this.bocalCalculator.espessuraCorroidaCasco) - this.bocalCalculator.espessuraMinimaCasco))) * this.bocalCalculator.tensaoAdmissivelCasco).toFixed(3)));
          if ((((this.bocalCalculator.areaRequerida - this.bocalCalculator.A1) + (2 * this.bocalCalculator.espessuraCorroidaBocal * this.bocalCalculator.razaoSnSv * ((this.bocalCalculator.eficienciaJuntaCasco * (this.bocalCalculator.espessuraCorroidaCasco)) - this.espessuraMinimaCascoCalculada))) * this.bocalCalculator.tensaoAdmissivelCasco) > 0) {
            this.bocalCalculator.cargaTotalSoldas = this.converterParaFloat(((((this.bocalCalculator.areaRequerida - this.bocalCalculator.A1) + (2 * this.bocalCalculator.espessuraCorroidaBocal * this.bocalCalculator.razaoSnSv * ((this.bocalCalculator.eficienciaJuntaCasco * (this.bocalCalculator.espessuraCorroidaCasco)) - this.espessuraMinimaCascoCalculada))) * this.bocalCalculator.tensaoAdmissivelCasco)).toFixed(3));
          } else {
            this.bocalCalculator.cargaTotalSoldas = 0;
          }

          //Carga na linha de falha 1-1
          //=(H56+H65+H58+H59)*E37
          this.bocalCalculator.cargaLinhaFalha11 = this.converterParaFloat(((this.bocalCalculator.A2 + this.bocalCalculator.areaChapaReforco + this.bocalCalculator.areaSoldaExterna + this.bocalCalculator.areaSoldaPadCostado) * this.bocalCalculator.tensaoAdmissivelCasco).toFixed(3));
          
          //carga na linha de falha 2-2
          //=(H56+H62+H58+H60+(2*H40*E40*H48))*E37
          this.bocalCalculator.cargaLinhaFalha22 = this.converterParaFloat(((this.bocalCalculator.A2 + this.bocalCalculator.areaBocalPenetraCasco + this.bocalCalculator.areaSoldaExterna + this.bocalCalculator.areaSoldaInterna + (2 * this.bocalCalculator.espessuraCorroidaBocal * this.bocalCalculator.eficienciaJuntaCasco * this.bocalCalculator.espessuraCorroidaCasco * this.bocalCalculator.razaoSnSv)) * this.bocalCalculator.tensaoAdmissivelCasco).toFixed(3));

          //carga na linha de falha 3-3
          //=(H56+H62+H65+H59+H58+H60+(2*H40*E40*H48))*E37
          this.bocalCalculator.cargaLinhaFalha33 = this.converterParaFloat(((this.bocalCalculator.A2 + this.bocalCalculator.areaBocalPenetraCasco + this.bocalCalculator.areaChapaReforco + this.bocalCalculator.areaSoldaPadCostado + this.bocalCalculator.areaSoldaExterna + this.bocalCalculator.areaSoldaInterna + (2 * this.bocalCalculator.espessuraCorroidaBocal * this.bocalCalculator.eficienciaJuntaCasco * this.bocalCalculator.espessuraCorroidaCasco * this.bocalCalculator.razaoSnSv)) * this.bocalCalculator.tensaoAdmissivelCasco).toFixed(3));

          //Tensao admissivel para as soldas
          //=SE(G31>0;MÍNIMO(E37;H37;G31);MÍNIMO(E37;H37))
          this.bocalCalculator.tensaoAdmissivelSoldas = this.converterParaFloat((this.bocalCalculator.tensaoAdmissivelChapaReforco > 0 ? Math.min(this.bocalCalculator.tensaoAdmissivelCasco, this.bocalCalculator.tensaoAdmissivelBocal, this.bocalCalculator.tensaoAdmissivelChapaReforco) : Math.min(this.bocalCalculator.tensaoAdmissivelCasco, this.bocalCalculator.tensaoAdmissivelBocal)).toFixed(3));

          //Cisalhamento Solda do bocal/Pad ou Casco (leg2)
          //=3,1416*0,5*(G23+2*H39)*(E58)*0,49*I104
          this.bocalCalculator.cisalhamentoSoldaBocalPad = this.converterParaFloat((Math.PI * 0.5 * (this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.espessuraNominalBocal) * this.bocalCalculator.extBocalcostPad * 0.49 * this.bocalCalculator.tensaoAdmissivelSoldas).toFixed(3));
          //Cisalhamento Solda do Pad/Casco (leg1)
          //=0,5*3,1416*G32*E59*0,49*I104
          this.bocalCalculator.cisalhamentoSoldaPadCasco = this.converterParaFloat((0.5 * Math.PI * this.bocalCalculator.diametroChapaReforco * this.bocalCalculator.padCostado * 0.49 * this.bocalCalculator.tensaoAdmissivelSoldas).toFixed(3));
          //Tração Solda de topo do Pad/Casco
          //=0,5*3,1416*(G23+2*H39)*G30*0,74*I104
          this.bocalCalculator.tracaoSoldaTopoPadCasco = this.converterParaFloat((0.5 * Math.PI * (this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.espessuraNominalBocal) * this.bocalCalculator.espessuraChapaReforco * 0.74 * this.bocalCalculator.tensaoAdmissivelSoldas).toFixed(3));
          //Tração Solda de topo do Casco/Bocal
          //=0,5*3,1416*(G23+2*H39)*E40*0,74*I104
          this.bocalCalculator.tracaoSoldaTopoCascoBocal = this.converterParaFloat((0.5 * Math.PI * (this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.espessuraNominalBocal) * this.bocalCalculator.espessuraCorroidaCasco * 0.74 * this.bocalCalculator.tensaoAdmissivelSoldas).toFixed(3));
          //No Bocal
          //=(3,1416*(((G23+2*H39)+(G23+2*G27))/4)*H40*0,7*I104)
          this.bocalCalculator.resistenciaBocal = this.converterParaFloat((Math.PI * (((this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.espessuraNominalBocal) + (this.bocalCalculator.diametroInternoAbertura + 2 * this.bocalCalculator.corrosaoAdmissivelBocal)) / 4) * this.bocalCalculator.espessuraCorroidaBocal * 0.7 * this.bocalCalculator.tensaoAdmissivelSoldas).toFixed(3));
          //Na Chapa de Reforço
          //=H65*G31
          this.bocalCalculator.resistenciaChapaReforco = this.converterParaFloat((this.bocalCalculator.areaChapaReforco * this.bocalCalculator.tensaoAdmissivelChapaReforco).toFixed(3));
          
          //Resistência da linha de falha 1-1
          //=I106+I105+I109
          this.bocalCalculator.resistenciaLinha11 = this.converterParaFloat((this.bocalCalculator.cisalhamentoSoldaPadCasco + this.bocalCalculator.cisalhamentoSoldaBocalPad + this.bocalCalculator.resistenciaBocal).toFixed(3));
          //resultado linha de falha 1-1
          //=SE(E115>MÁXIMO(I98;I99);"Aprovado!";"Falha!")
          this.bocalCalculator.resultadoLinha11 = this.bocalCalculator.resistenciaLinha11 > Math.max(this.bocalCalculator.cargaTotalSoldas, this.bocalCalculator.cargaLinhaFalha11) ? "Approved!" : "Failed!";
          
          //Resistência da linha de falha 2-2
          //=I105+I107+I108
          this.bocalCalculator.resistenciaLinha22 = this.converterParaFloat((this.bocalCalculator.cisalhamentoSoldaBocalPad + this.bocalCalculator.tracaoSoldaTopoPadCasco + this.bocalCalculator.tracaoSoldaTopoCascoBocal).toFixed(3));
          //resultado linha de falha 2-2
          //=SE(E119>MÁXIMO(I98;I100);"Aprovado!";"Falha!")
          this.bocalCalculator.resultadoLinha22 = this.bocalCalculator.resistenciaLinha22 > Math.max(this.bocalCalculator.cargaTotalSoldas, this.bocalCalculator.cargaLinhaFalha22) ? "Approved!" : "Failed!";
          
          //resistência da linha de falha 3-3
          //=I106+I105+I108
          this.bocalCalculator.resistenciaLinha33 = this.converterParaFloat((this.bocalCalculator.cisalhamentoSoldaPadCasco + this.bocalCalculator.cisalhamentoSoldaBocalPad + this.bocalCalculator.tracaoSoldaTopoCascoBocal).toFixed(3));
          //resultado linha de falha 3-3
          //=SE(E122>MÁXIMO(I98;I101);"Aprovado!";"Falha!")
          this.bocalCalculator.resultadoLinha33 = this.bocalCalculator.resistenciaLinha33 > Math.max(this.bocalCalculator.cargaTotalSoldas, this.bocalCalculator.cargaLinhaFalha33) ? "Approved!" : "Failed!";
          
          //Na chapa de reforço R1 > R6
          //=I106
          this.bocalCalculator.resultadoChapaReforco = this.bocalCalculator.cisalhamentoSoldaBocalPad;

          if(Math.abs((this.bocalCalculator.diametroInternoAbertura +2* this.bocalCalculator.espessuraNominalBocal) - (this.bocalCalculator.externalRadiusNozzle)) > 0.05) {
            this.bocalCalculator.alertaErrdimensionalBocal = "Verify the nozzle geometry!";
          } else {
            this.bocalCalculator.alertaErrdimensionalBocal = "OK";
          }
        },
        converterParaFloat(valor) {
            if (valor === "" || valor === null || valor === undefined) {
                return 0;
            }

            let valorString = valor.toString().trim();

            if (valorString.includes(",") && valorString.includes(".")) {
                const ultimoPonto = valorString.lastIndexOf(".");
                const ultimaVirgula = valorString.lastIndexOf(",");
                const separadorDecimal = ultimaVirgula > ultimoPonto ? "," : ".";
                const separadorMilhar = separadorDecimal === "," ? "." : ",";

                valorString = valorString
                    .replace(new RegExp(`\\${separadorMilhar}`, "g"), "")
                    .replace(separadorDecimal, ".");
            } else if (valorString.includes(",")) {
                valorString = valorString.replace(",", ".");
            }

            const valorConvertido = parseFloat(valorString);
            return isNaN(valorConvertido) ? 0 : valorConvertido;
        },
    },
};
</script>

<style scoped>
h5.text-primary {
  margin-bottom: 1rem;
  padding: 8px 12px;
  border-left: 4px solid #0056ff;
  border-bottom: 1px solid #e6ecf5;
  color: #0056ff !important;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.bocal-desenho {
  padding-top: 24px;
  padding-bottom: 24px;
}
</style>

<style>
.material-table {
  overflow: visible !important;
}

.material-options {
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  top: 100%;
  left: 0;
  z-index: 9999;
  border: 1px solid #d7e0ed;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(23, 32, 51, 0.14);
}

.material-option {
  cursor: pointer;
  color: #334e73;
  padding: 11px 14px;
  white-space: normal;
}

.material-option:hover,
.material-option:focus {
  background-color: #edf4ff;
  color: #0056ff;
}

.col-symbol {
    width: 50px !important;
    text-align: center;
}

.img-drawing-bocal{
  width: 1200px !important;
  max-width: 80% !important;
  display: block;
  margin: 0 auto;
}

.img-legenda-drawing-bocal{
  width: 1200px !important;
  max-width: 70% !important;
  display: block;
  margin: 0 auto;
}

</style>